import useSWR from "swr";

/* ===================== GET COUNTRIES ===================== */

export function useGetCountries(enabled = true) {
  const key = enabled ? ["COUNTRIES_LIST"] : null;

  const fetcher = async () => {
    const res = await fetch(
      "https://restcountries.com/v3.1/all?fields=name,cca2,idd,flags"
    );

    if (!res.ok) {
      throw new Error("Failed to fetch countries");
    }

    const data = await res.json();

    return data
      .map((c) => ({
        name: c.name?.common || "",
        code: c.cca2 || "",
        callingCode:
          c.idd?.root && c.idd?.suffixes?.length
            ? `${c.idd.root}${c.idd.suffixes[0]}`
            : "",
        flag: c.flags?.png || "",
      }))
      .filter((c) => c.callingCode) 
      .sort((a, b) => a.name.localeCompare(b.name));
  };

  const { data, error, isLoading } = useSWR(key, fetcher);

  return {
    countries: data || [],
    isLoading,
    error,
  };
}
